"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var transparentCover_1 = require("spry-react/LoadingCover/transparentCover");
var loadingCover_1 = require("spry-react/LoadingCover/loadingCover");
var ActiveState;
(function (ActiveState) {
    ActiveState[ActiveState["Off"] = 0] = "Off";
    /* indicates the cover is present but not visible to the user */
    ActiveState[ActiveState["Passive"] = 1] = "Passive";
    /* indicates the cover is present and displaying the working spinner */
    ActiveState[ActiveState["Active"] = 2] = "Active";
})(ActiveState = exports.ActiveState || (exports.ActiveState = {}));
var activeIndicatorDelayInMs = 250;
var DelayedLoadingCover = /** @class */ (function (_super) {
    __extends(DelayedLoadingCover, _super);
    function DelayedLoadingCover(props) {
        var _this = _super.call(this, props) || this;
        _this.activeIndicatorTimeout = null;
        _this.showActiveIndicator = function () {
            _this.stopActiveIndicatorTimeout();
            _this.setState({ activeIndicatorVisible: true });
        };
        _this.onTransparentCoverClick = function () {
            _this.showActiveIndicator();
        };
        _this.state = { activeIndicatorVisible: props.active === ActiveState.Active };
        if (_this.props.active === ActiveState.Passive) {
            _this.startActiveIndicatorTimeout();
        }
        return _this;
    }
    DelayedLoadingCover.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(transparentCover_1.TransparentCover, { key: "transparent-cover", active: this.isActive(), onClick: this.onTransparentCoverClick }),
            React.createElement(loadingCover_1.LoadingCover, { key: "loading-cover", active: this.state.activeIndicatorVisible }));
    };
    DelayedLoadingCover.prototype.isActive = function () {
        return this.props.active === ActiveState.Passive || this.props.active === ActiveState.Active;
    };
    DelayedLoadingCover.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.active === ActiveState.Passive) {
            if (!this.state.activeIndicatorVisible) {
                this.startActiveIndicatorTimeout();
            }
        }
        else if (nextProps.active === ActiveState.Active) {
            this.showActiveIndicator();
        }
        else {
            this.stopActiveIndicatorTimeout();
            this.setState({ activeIndicatorVisible: false });
        }
    };
    DelayedLoadingCover.prototype.startActiveIndicatorTimeout = function () {
        if (this.activeIndicatorTimeout === null) {
            this.activeIndicatorTimeout = window.setTimeout(this.showActiveIndicator, activeIndicatorDelayInMs);
        }
    };
    DelayedLoadingCover.prototype.stopActiveIndicatorTimeout = function () {
        if (this.activeIndicatorTimeout !== null) {
            window.clearTimeout(this.activeIndicatorTimeout);
            this.activeIndicatorTimeout = null;
        }
    };
    DelayedLoadingCover.prototype.componentWillUnmount = function () {
        this.stopActiveIndicatorTimeout();
    };
    return DelayedLoadingCover;
}(React.Component));
exports.DelayedLoadingCover = DelayedLoadingCover;
